// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '../../../Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
var DeviationPageHeader = function () {
    var isMobile = useContext(MobileContext);
    var isInDuperbrowse = useDuperbrowseViewType().isInDuperbrowse;
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var adsNitro = useFlag('ads_nitro');
    if (!isMobile) {
        return React.createElement(SiteHeader, null);
    }
    if (isInDuperbrowse || (adsEnabled && adsNitro)) {
        return (React.createElement(Sticky, { marginTop: -1 }, function (isStuck) { return (React.createElement(MobileSubmissionDetailsHeader, { isSticky: true, isStuck: isStuck })); }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteHeader, null),
        React.createElement(MobileSubmissionDetailsHeader, { isSticky: false })));
};
DeviationPageHeader.displayName = 'DeviationPageHeader';
export default DeviationPageHeader;
//# sourceMappingURL=DeviationPageHeader.js.map